import * as React from "react";
const SvgKlaviyo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 11, viewBox: "0 0 17 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.2 10.8H0V0H16.2L12.8071 5.4L16.2 10.8Z", fill: "black" }));
export default SvgKlaviyo;
